import React, { useEffect } from "react";
import "../style/about.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";

const JoinUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="about">
        <div className="contain">
          <div className="title">Join Us</div>
          <p>
            Join our team of OUT OF STOCK! We are currently looking for diverse
            talents with shared visions to grow your dynamic careers here and to
            challenge the status quo. If you think you have what it takes to
            join our inspirational team, find the opportunity that is right for
            you below.
          </p>
          <p>Project Executive</p>
          <p>
            What to Do: 1. Liaise, meet, co-ordinate work issues with clients,
            subcontractors and site foremen to ensure timely completion of
            projects assigned 2. Attend site progress meetings, and provide
            reports 3. Check and supervise all works performed by subcontractors
            on site to ensure that quality works are produced 4. Assist with
            task breakdown, risk assessment, project planning for each project
            before it starts, and assist (or take the lead as appropriate) in
            monitoring and controlling during the project lifecycle 5. Ensure
            that all project-related documents are produced in a timely fashion,
            kept up to date and are made accessible to project teams and company
            employees, as appropriate 6. Handle the operations and logistics of
            projects 7. Assist with regular reporting on project status 8.
            Involve in project tenders, proposals and all related matters 9.
            Co-ordinate and sequence subcontractors work according to the master
            and detailed construction schedules to prevent delays 10. Inspect
            project materials delivered on site by the suppliers, vendors to
            ensure they meet specified requirements and to arElviroxab for any
            testing required 11. Assist in the handing over of completed works
            and rectification of any defects by the appropriate subcontractors
            Other Requirements: 1. Degree holder in Engineering/ Architectural
            studies or related discipline 2. Experience in master planning, a
            track record on mixed projects is essential and admin/project
            management experience is beneficial 3. Good communication,
            interpersonal skills, and able to interact with people of all levels
            and teamwork How to Apply: Applicants are required to submit a
            resume in a combined PDF document. Applications will be treated in
            the strictest confidence. Personal data collected will be used for
            recruitment purposes only.
          </p>
          <p>Senior Interior Designer</p>
          <p>
            What to Do: 1. Develop concept designs through to practical
            completion 2. Prepare design development presentations and
            documentation 3. Liaise with engineering services and specialist sub
            consultants 4. Manage construction documentation package including
            drawings, schedules and specifications Other Requirements: 1. Degree
            holder in Interior Design/ Interior Architecture or related
            discipline 2. Up to 3 years of experience (or equivalent) of
            residential and interior architecture projects 3. Rhino and Adobe
            Creative Suite proficiency is required How to Apply: Applicants are
            required to submit a resume and portfolio in a combined PDF
            document. Applications will be treated in the strictest confidence.
            Personal data collected will be used for recruitment purposes only.
          </p>
          <p>Art Director</p>
          <p>
            What to Do: 1. Lead and brainstorm with a creative team to develop
            ideas for campaigns and projects 2. Pitch concepts to clients by
            means of innovative presentations 3. Constantly liaise with clients
            during a project regarding progress, issues and changes 4. Nurture a
            work environment that is conducive to creative thinking Other
            Requirements: 1. 5+ year’s experience working at a similar level in
            a creative industry 2. Experience in working with retail based
            marketing communications 3. Solid all round experience with regard
            to both copy writing and art direction 4. Adobe Creative Suite
            proficiency is required How to Apply: Applicants are required to
            submit a resume and portfolio in a combined PDF document.
            Applications will be treated in the strictest confidence. Personal
            data collected will be used for recruitment purposes only.
          </p>
          <p>Sales Executive</p>
          <p>
            What to Do: 1. Provide high quality customer service and manage
            customer’s experience in the most positive way 2. Plan, execute and
            supervise comprehensive projects including interior design projects,
            furniture production and development and online retail business 3.
            Prepare necessary administrative works including quotations, project
            submissions and reports 4. Liaise with vendors, contractors as well
            as internal departments Other Requirements: 1. Higher Diploma or
            University graduate 2. Minimum 2 years related working experience,
            less experience will also be considered as trainee 3. Candidate with
            VM and/or Design knowledge and skills is a definite advantage 4.
            Creative, proactive and detail-oriented 5. Able to work under
            pressure and tight deadlines How to Apply: Applicants are required
            to submit a resume in a combined PDF document. Applications will be
            treated in the strictest confidence. Personal data collected will be
            used for recruitment purposes only.
          </p>
          <p>Multimedia Designer</p>
          <p>
            What to Do: 1. Layout design and artwork production of marketing
            materials to support sales campaigns and promote brand image 2. Plan
            and manage social media content and marketing strategies to enhance
            website traffic and social media engagement 3. Take and retouch
            photos, shoot and edit videos 4. Devise and present marketing ideas
            and strategies, planning and execution of campaigns 5. Manage
            incoming media or customer enquiries in an efficient and
            professional manner Other Requirements: 1. Higher Diploma or above
            in Graphic Design, Multimedia, Digital Media, Marketing,
            Communications or related disciplines 2. Proficient in Adobe
            Creative Suite 3. Skilled in photography, with knowledge and
            experience of video shooting and editing 4. Good communication
            skills in both Chinese and English 5. Knowledge and understanding of
            social media platforms is an advantage 6. Creative, proactive and
            detail-oriented 7. Independent, able to work under pressure and
            tight deadlines 8. Fresh graduates will also be considered How to
            Apply: Applicants are required to submit a resume and portfolio in a
            combined PDF document. Applications will be treated in the strictest
            confidence. Personal data collected will be used for recruitment
            purposes only.
          </p>
          <p>Internship</p>
          <p>
            Internship opportunities available. We take interns only for a
            minimum of four months, as our experience is that only after two
            month the collaboration starts to be mutually fruitful and fun. We
            can therefore only take a limited number of interns per year. How to
            Apply: Applicants are required to submit a resume and portfolio in a
            combined PDF document. Applications will be treated in the strictest
            confidence. Personal data collected will be used for recruitment
            purposes only.
          </p>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default JoinUs;
